import { render, staticRenderFns } from "./EditTldPopup.vue?vue&type=template&id=325863b4&scoped=true"
import script from "./EditTldPopup.vue?vue&type=script&lang=js"
export * from "./EditTldPopup.vue?vue&type=script&lang=js"
import style0 from "./EditTldPopup.vue?vue&type=style&index=0&id=325863b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325863b4",
  null
  
)

export default component.exports